// OT shares date/time formatting and patient form helpers with Dialysis so both modules display the same way.
export {
  blankPatientFields,
  blankResponsiblePerson,
  dateTimeInput,
  formatDialysisDate as formatOtDate,
  formatDialysisDateTime as formatOtDateTime,
  formatDialysisTime as formatOtTime,
  patientFieldsFromOption,
  timeInput,
  todayInput,
} from '../dialysis/dialysis.utils';

export const statusLabels: Record<string, string> = {
  registered: 'Registered',
  scheduled: 'Scheduled',
  'in-progress': 'In Progress',
  completed: 'Completed',
  cancelled: 'Cancelled',
};

/** Local calendar date (YYYY-MM-DD) of a stored date, for date inputs. */
export const toDateInput = (value: string) => {
  const date = new Date(value);
  const offset = date.getTimezoneOffset();
  return new Date(date.getTime() - offset * 60_000).toISOString().slice(0, 10);
};
